//@helpers
const { APIPost } = require('utilities/APIRequestHelper');
const { getURL }  = require('core/apiURLBuilder')
//@constants
const actionTypes = require('constants/actionTypes');

const forceValidate = () => ({
    type: actionTypes.HIRE_CARD_PIN_SET_FORCE_VALIDATE,
});

const doValidate = birthDate => ({
    type: actionTypes.HIRE_CARD_PIN_SET_VALIDATE_STEP,
    payload: {
        birthDate,
    }
});

const validate = () => (dispatch, getState) => {
    dispatch(doValidate(getState().profile.get('fechaNacimiento')));
};

const setPin = (pin, pinType)  => ({
    type: actionTypes.HIRE_CARD_PIN_SET_SET_PIN,
    payload: {
        pin,
        pinType,
    }
});

const requestPinSetSuccess = () => ({
    type: actionTypes.HIRE_CARD_PIN_SET_SUCCESS,
});

const requestPinSetRequest = () => ({
    type: actionTypes.HIRE_CARD_PIN_SET_REQUEST,
});

const requestPinSetFailure = errorMsg => ({
    type: actionTypes.HIRE_CARD_PIN_SET_FAILURE,
    payload: {
        errorMsg,
    }
});

const reset = () => ({
    type: actionTypes.HIRE_CARD_PIN_SET_RESET,
});

const requestPinSet = (contract, product, currentCard, personCode, personType) => (dispatch, getState) => {
    const newPin = getState().hireCardPinSet.get('newPin');
    const card = !!currentCard && currentCard.split('.');

    const params = {
        query: {
            contrato: {
                numeroContrato: contract,
                producto: product,
            },
            estandarRef: {
              codigoEstandar: `0000${card[3]}`,
              subTipoProducto: card[2],
              tipoProducto: card[1],
            },
            persona: {
              codigoPersona: personCode,
              tipoPersona: personType,
            },
            pin: parseInt(newPin),
        }
    };

    dispatch(requestPinSetRequest());

    return APIPost(dispatch, getURL('cardPinSet'), params)
        .then(response => {
            return dispatch(requestPinSetSuccess(response));
        })
        .catch(response => {
            dispatch(requestPinSetFailure(response.errorMsg));
            throw response;
        }
    );
};

module.exports = {
    forceValidate,
    requestPinSet,
    reset,
    setPin,
    validate,
};
